module.exports = __webpack_public_path__ + "img/gb800.prt.1ac60320.jpg";